import ClassenService from '../ClassenService';

class CollectionService {
  getCollections() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/collections`);
  }

  addCollection(data) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/collections`, 'addCollection', data);
  }

  getCollection(collectionId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/collections/${collectionId}`);
  }

  updateCollection(collectionId, collectionData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/collections/${collectionId}`, 'updateCollection', collectionData);
  }

  deleteCollection(collectionId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/collections/${collectionId}`, 'deleteCollection');
  }
}

export default new CollectionService();
